const form_name = 'userProfileForm';

const fields = {
  first_name: 'first_name',
  last_name: 'last_name',
  user_name: 'user_name',
  email: 'email',
  phone_code: 'phone_code',
  phone_number: 'phone_number',
  country: 'country',
  zip: 'zip',
  address1: 'address1',
  address2: 'address2',
  city: 'city',
};

export default {
  form_name,
  fields,
};



// WEBPACK FOOTER //
// ./src/app/main/user-profile/constants/user-profile-constants.js